var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99998 0C10.5344 0 10.9677 0.433273 10.9677 0.967742V9.03224H19.0323C19.5667 9.03224 20 9.46551 20 9.99998C20 10.5344 19.5667 10.9677 19.0323 10.9677H10.9677V19.0323C10.9677 19.5667 10.5344 20 9.99998 20C9.46551 20 9.03224 19.5667 9.03224 19.0323V10.9677H0.967742C0.433273 10.9677 0 10.5344 0 9.99998C0 9.46551 0.433273 9.03224 0.967742 9.03224H9.03224V0.967742C9.03224 0.433273 9.46551 0 9.99998 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.0b14c68153c468177acd101a13348040.svg";
export { ForwardRef as ReactComponent };